import { toYMD } from '@/lib/utils';
import React from 'react';

interface Note {
  id: string;
  createdBy: string;
  createdByName: string;
  createdAt: string;
  note: string;
}

interface NotesHistoryProps {
  notes: Note[];
}

const NotesHistory: React.FC<NotesHistoryProps> = ({ notes }) => {
  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold text-orange-500 mb-4">
        Notes History:
      </h3>
      {notes.length > 0 ? (
        <ol className="space-y-3">
          {notes.map((note, index) => (
            <li key={note.id} className="text-sm leading-relaxed">
              <span className="font-bold text-blue-800">
                {index + 1}. Remark By: {note.createdByName} - On {toYMD(note.createdAt)} - 
              </span>
              <span className="text-gray-700 ml-1">
                {note.note}
              </span>
            </li>
          ))}
        </ol>
      ) : (
        <p className="text-gray-500 italic">No notes history available.</p>
      )}
    </div>
  );
};

export default NotesHistory;
